//--------------------------------------------
//
// Skybox Collection
//
//--------------------------------------------
'use strict';


export default [

	[
		'img/textures/room2_front.jpg',
		'img/textures/room2_back.jpg',
		'img/textures/room2_up.jpg',
		'img/textures/room2_down.jpg',
		'img/textures/room2_right.jpg',
		'img/textures/room2_left.jpg'
	],

	[
		'img/textures/logo_front.jpg',
		'img/textures/logo_back.jpg',
		'img/textures/logo_up.jpg',
		'img/textures/logo_down.jpg',
		'img/textures/logo_right.jpg',
		'img/textures/logo_left.jpg'
	],

	[
		'img/textures/panel.jpg',
		'img/textures/panel.jpg',
		'img/textures/panel.jpg',
		'img/textures/panel.jpg',
		'img/textures/panel.jpg',
		'img/textures/panel.jpg'

	],


	[
		'img/textures/water.jpg',
		'img/textures/water.jpg',
		'img/textures/water.jpg',
		'img/textures/water.jpg',
		'img/textures/water.jpg',
		'img/textures/water.jpg'
	]
	
];
